/**
 * Pure decision for the ONE auto-open trigger of the generator's checkout
 * popup: did THIS completed generation just spend the last sign-up credits a
 * non-purchaser had for another generation? (Since 2026-10-12 there is no
 * separate free trial: a new account spends its 10 sign-up credits.)
 *
 * Lives in its own plain (non-JSX) module — rather than inline in
 * AiGenerator.js — specifically so it can be unit tested with plain Node,
 * without a JSX/React test harness (this repo has none; see
 * app/ai-generator/__tests__/checkoutAutoopen.test.js). No hooks, no DOM,
 * everything it needs is passed in rather than read from closure.
 *
 * @param {object} p
 * @param {boolean} p.wasSpendingSignupCredits - true only when the generate
 *   that just completed was armed by a non-purchaser (set by onGenerate in
 *   AiGenerator.js; never true for a refine, a sample, or a purchaser).
 * @param {object|null} p.quota - the GET /quota response fetched right after
 *   this completion (the transition is read off this fresh value, never off
 *   a value from a page load — that is what keeps a reload of an
 *   already-empty account from popping it). An older backend without
 *   `credits` never fires.
 * @returns {boolean}
 */
export function shouldAutoOpenCheckout({ wasSpendingSignupCredits, quota }) {
  if (!wasSpendingSignupCredits || !quota) return false;
  if (quota.has_purchased_credits) return false;
  if (!quota.checkout_autoopen_enabled) return false;
  if (typeof quota.credits !== 'number') return false;
  const price = typeof quota.pricing?.generation === 'number' ? quota.pricing.generation : 1;
  return quota.credits < price;
}
